<script>
	import { createEventDispatcher, getContext, onDestroy, onMount } from 'svelte';

	import { keyToken, keyUser, ROLE_VIEWER } from '../globals.js';
	import { formatPercent } from './formatting.js';

	const dispatch = createEventDispatcher();

	const { getToken } = getContext(keyToken);
	const token = getToken();
	const { getUser } = getContext(keyUser);
	const user = getUser();

	const tickerUpdateTimeInMillis = 6;

	let stocks = [];
	let x = 0;
	let width = 0;
	let pos;
	let timer;
	let liveUpdates = true;

	function toggleLiveUpdates() {
		liveUpdates = !liveUpdates;
		if (liveUpdates) {
			timer = setInterval(animateTicker, tickerUpdateTimeInMillis);
		} else {
			if (timer != null) {
				clearInterval(timer);
			}
		}
	}

	async function loadAssets() {
		if (!token) {
			console.warn('Not logged in!');
			return;
		}

		await fetch('https://ostium.ch/api/borsalino/get_assets.php', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json;charset=utf-8',
				'Authorization': 'JWT ' + encodeURIComponent(token)
			}
		}).then(result => {
			if (result.ok) {
				console.log('Loaded stock ticker data successfully.');
				result.json().then(data => {
					stocks = data.filter(stock => stock.historic === 0 && !stock.name.startsWith('^')).map(stock => {
						stock.delta = stock.last - stock.close_year;
						stock.delta_percent = stock.last / stock.close_year - 1;
						return stock;
					});
					console.log(`Loaded ${data.length} asset${data.length === 1 ? '' : 's'}, displaying ${stocks.length} in stock ticker.`);
				});
			} else {
				console.warn('Could not load assets.', result.statusText);
			}
		});
	}

	async function updatePrices() {
		if (!token) {
			console.warn('Not logged in!');
			return;
		}
		if (user == null || user.role_id === ROLE_VIEWER) {
			return;
		}

		await fetch('https://ostium.ch/api/borsalino/update_all_prices.php', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json;charset=utf-8',
				'Authorization': 'JWT ' + encodeURIComponent(token)
			}
		}).then(result => {
			if (result.ok) {
				result.json().then(data => {
					console.group('Update prices');
					if (data.hasOwnProperty('error')) console.error(data.error);
					if (data.hasOwnProperty('warning')) console.warn(data.warning);
					if (data.hasOwnProperty('message')) console.log(data.message);
					if (data.hasOwnProperty('info')) console.info(data.info);
					console.groupEnd();

					if (data.message != null) {
						dispatch('update', {
							type: 'prices',
							text: data.message
						});
					}
				});
			} else {
				console.warn('Could not update prices.', result.statusText);
			}
		});
	}

	function animateTicker() {
		x -= 1;
		let card = document.getElementById('stock-1-' + (stocks.length > 0 ? stocks[0].id : 0));
		if (card != null) {
			pos = card.getBoundingClientRect().left;
		}
		if (x + 10 * width < 0 || pos < 0) {
			x = 0;
			pos = width;
			updatePrices();
			loadAssets();
		}
	}

	onDestroy(() => {
		if (timer != null) {
			clearInterval(timer);
		}
	});

	onMount(() => {
		loadAssets();
		let ticker = document.getElementById('ticker');
		width = Math.max(ticker.clientWidth, ticker.offsetWidth, ticker.scrollWidth, ticker.getBoundingClientRect().width);
		width = ticker.scrollWidth;
		pos = width;
		timer = setInterval(animateTicker, tickerUpdateTimeInMillis);
	});
</script>

<style>
	:root {
		--background-color: #324;
	}

	.stockTicker {
		background-color: var(--background-color);
		display: flex;
		overflow: hidden;
		position: relative;
	}

	.stockCard {
		padding: .5rem;
		white-space: nowrap;
	}

	.custom-switch {
		background-color: var(--background-color);
		position: absolute;
		padding: .5rem;
		right: 0;
		top: 0;
	}
</style>

<div id="ticker" class="stockTicker" style="margin-left: {x}px">
	{#each [0,1] as index (index)}
	{#each stocks as stock (stock.id)}
	<div id="stock-{index}-{stock.id}" class="stockCard {'text-' + (stock.last < stock.close_year ? 'danger' : 'success')}">
		<span>{stock.symbol}</span>
		<span>{formatPercent(stock.delta_percent)}</span>
	</div>
	{/each}
	{/each}

	<div class="custom-control custom-switch">
		<input type="checkbox" class="custom-control-input" id="liveUpdates" checked={liveUpdates} on:click={toggleLiveUpdates}>
		<label class="custom-control-label" for="liveUpdates">Live updates</label>
	</div>
</div>
